import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { roleAccesscolumns } from './RoleAccessTableData';
import DataTable from '../../../../Common/DataTable/DataTable';
import DataTableHeader from '../../../../Common/DataTableHeader/DataTableHeader';
import DataTableFooter from '../../../../Common/DataTableFooter/DataTableFooter';
import api, { RBAC_BASE } from '../../../../api/rbacApi';

const RoleAccessTable = () => {
  const [dataT, setDataT] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get(`${RBAC_BASE}/user-role-mapping`);
    setDataT(res.data);
  };

  const formattedData = dataT.map((data) => ({
    id: data.intUserId,
    userName: data.vchFullName,
    roleName: data.nvchDesigName || "Not Assigned",

    action: (
      <Link to={`/role-assign/${data.intUserId}`} className="btn">
        <i className="bi bi-pencil-square"></i>
      </Link>
    ),
  }));

  return (
    <>
      {/* <DataTableHeader /> */}
      <DataTable columns={roleAccesscolumns} data={formattedData} />
      {/* <DataTableFooter dataT={formattedData} /> */}
    </>
  );
};

export default RoleAccessTable;